import { Col, Row } from "react-bootstrap";

const CourseInstructor = ({
  instructor_img,
  instructor_name,
  instructor_description,
}) => {
  return (
    <Row className="align-items-center g-3">
      <Col
        xs={12}
        sm={12}
        md={3}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <img
          src={instructor_img}
          alt="Instructor Image"
          style={{ width: "180px", height: "180px" }}
          className="img-fluid rounded-circle"
        />
        <p className="trustedge_size18 trustedge_weight-600 mt-2">{instructor_name}</p>
      </Col>
      <Col xs={12} sm={12} md={9} className="mb-2 text-md-start">
        <p className="trustedge_size18 mb-0 mb-5 px-5 pe-md-5 instructor-desc-mob">
          {instructor_description}
        </p>
      </Col>
    </Row>
  );
};

export default CourseInstructor;
